export const styles = theme => ({
  container: {
    marginRight: theme.spacing.unit * 3
  }
})



// WEBPACK FOOTER //
// ./src/components/WaitingListIcon/styles.js